import { createRef, useEffect, useState } from "react";


import WebDesigner from "../WebDesigner";

import { CreateBlankLayoutNode } from "../WBCanvas";
import { GetWBComponentByTypename } from "../Data/WBData";

import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import Accordian from "../Accordian";
import { WBComponent } from "../WBComponents/WBComponent";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { EditorState } from "../EditorTypes";
import ConnectDomainClickAd from "../Adds/ConnectDomainClickAd";
import store from "app/store";
import { MultiLocationLive } from "components/Multilocation/MulitLocationLIve";
import { LoginUserType } from "utils/Utils";

function WBComponentSlot(props: { component: WBComponent, manager: WebDesigner, isActive: boolean }) {

    const [inUse, setInUse] = useState(false);
    const handleMouseUp = () => {

        setInUse(false);

    }
    const onStartDrag = (e: any) => {
        if (e.button == 0 && props.isActive) {

            let layoutObj = CreateBlankLayoutNode(props.component.typename);
            props.manager.mouseX = e.clientX;
            props.manager.mouseY = e.clientY;
            props.manager.startDrag(layoutObj);
            let comp = GetWBComponentByTypename(props.component.typename);
            if (comp) {

            props.manager.draggedStartBounds = comp.defaultGridSize;
            }
            setInUse(true);
        }
    }

    useEffect(() => {

        if (props.isActive)
            document.addEventListener("pointerup", handleMouseUp);
        return () => {
            if (props.isActive)
                document.removeEventListener("pointerup", handleMouseUp);
        }
//eslint-disable-next-line
    }, [inUse])


    let className = (inUse || !props.isActive) ? "component-slot inactive" : "component-slot";

    return (

        <div className={className} id={"component-slot-" + props.component.displayName} onPointerDown={onStartDrag}>{props.component.icon}{props.component.displayName}</div>
    )



}

type WBComponentPanelLayoutDefinition = {
    label: string
    components: string[]
}

const layoutComponents: WBComponentPanelLayoutDefinition =
{
    label: "Layout",
    components:
        [
            wBComponentTypeNames.accordion,
            wBComponentTypeNames.container,
            wBComponentTypeNames.column,
            wBComponentTypeNames.grid,
            wBComponentTypeNames.spacer,
            wBComponentTypeNames.section,
            wBComponentTypeNames.tabRow,


        ]
};

const TextComponents: WBComponentPanelLayoutDefinition = {
    label: "Text",
    components: [
        wBComponentTypeNames.richText,
        wBComponentTypeNames.text,
        wBComponentTypeNames.heading,
    ]

}

const ElementComponents: WBComponentPanelLayoutDefinition = {
    label: "Elements",
    components: [
        wBComponentTypeNames.image,
        wBComponentTypeNames.button,
        wBComponentTypeNames.imageSlider,
        wBComponentTypeNames.beforeAndAfter,
        wBComponentTypeNames.videoPlayer,
        wBComponentTypeNames.iFrame,
        wBComponentTypeNames.htmlEmbed,
    ]
}

const VagaroComponents: WBComponentPanelLayoutDefinition = {
    label: "Vagaro",
    components: [
        wBComponentTypeNames.businessName,
        wBComponentTypeNames.businessBookNow,
        wBComponentTypeNames.businessCall,
        wBComponentTypeNames.businessClass,
        wBComponentTypeNames.businessDailyDeals,
        wBComponentTypeNames.businessDescription,
        wBComponentTypeNames.businessFacilityInformation,
        wBComponentTypeNames.businessForm,
        wBComponentTypeNames.businessGiftCertificates,
        wBComponentTypeNames.businessHours,
        //wBComponentTypeNames.businessLocation,
        wBComponentTypeNames.businessLogo,
        wBComponentTypeNames.businessMap,
        wBComponentTypeNames.businessMemberships,
        wBComponentTypeNames.businessMessage,
        wBComponentTypeNames.businessPackages,
        wBComponentTypeNames.businessProducts,
        wBComponentTypeNames.businessReviews,
        wBComponentTypeNames.businessreviewpercentage,
        wBComponentTypeNames.businessServices,
        wBComponentTypeNames.businessSocialLinks,
        wBComponentTypeNames.busienssStaff,
        wBComponentTypeNames.businessGallery,



    ]
}



// const Testing: WBComponentPanelLayoutDefinition = {
//     label: "Testing",
//     components: [


//         wBComponentTypeNames.productDetails,


//     ]

// }

const BloggingComponents: WBComponentPanelLayoutDefinition = {
    label: "Blogging",
    components: [

        wBComponentTypeNames.blogList,
        wBComponentTypeNames.blogSearch


    ]

}



const allComponents = [TextComponents, layoutComponents, ElementComponents, VagaroComponents,BloggingComponents];

export default function ComponentDesignPanel(props: { manager: WebDesigner, layout: LayoutNode }) {
    const containerRef = createRef<HTMLDivElement>();
    const contentRef = createRef<HTMLDivElement>();
    const [arrowState, setArrowState] = useState(0);//0 =none  1 = top 2= bottom 3=both

    const isMultipleLocation = ((props.manager.props.siteData.isMultipleLocation&&(MultiLocationLive||props.manager.props.siteData.userContext.userType == LoginUserType.VagaroAdmin ) )
    || props.manager.props.siteData.userContext.isAdmin);
    if(isMultipleLocation){
        if(!VagaroComponents.components.includes(wBComponentTypeNames.businessLocation)){
            VagaroComponents.components.splice(10,0,wBComponentTypeNames.businessLocation);
        }

        if(props.manager.props.siteData.isPromoCodeAddressBusiness && !VagaroComponents.components.includes(wBComponentTypeNames.businessOwnerName)){
            VagaroComponents.components.push("divider");
            if(props.manager.props.siteData.groupMysite == 2)
            {
                VagaroComponents.components.push(wBComponentTypeNames.businessHero);
                VagaroComponents.components.push(wBComponentTypeNames.businessNickName);
            }
            VagaroComponents.components.push(wBComponentTypeNames.businessOwnerName);
            if(props.manager.props.siteData.groupMysite == 2)
            {
                VagaroComponents.components.push(wBComponentTypeNames.dormantButton);
            }
            }

    }



    const checkArrows = (target: HTMLElement) => {
        let container = target?.parentElement;
        if (target.classList.contains("component-container")) {

            let temp = target;
            target = target.children[0] as HTMLElement;
            container = temp;
        }


        if (target && container) {


            if (container.scrollHeight > container.clientHeight) {

                if (container.scrollTop == 0) {


                    setArrowState(2);
                }
                else if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
                    setArrowState(1);
                }
                else {
                    setArrowState(3);
                }
            }
            else {
                setArrowState(0);
            }
        }
        else {
            console.log("err");
        }


    }

    useEffect(() => {

        const resizeObserver = new ResizeObserver(entries => {

            checkArrows(entries[0].target as HTMLElement);
        });

        if (contentRef.current) {
            resizeObserver.observe(contentRef.current);
        }

        return () => { resizeObserver.disconnect(); }
//eslint-disable-next-line
    }, [])

    const scrollContainer = (delta: number) => {

        if (containerRef.current) {

            let amount = containerRef.current.clientHeight / 2;

            let newScroll = containerRef.current.scrollTop + delta * amount;
            if (newScroll > containerRef.current.scrollHeight) {
                newScroll = containerRef.current.scrollHeight;
            }
            containerRef.current.scrollTo({ top: newScroll, behavior: "smooth" });

        }
    }

    const UpArrow = ({ active }: { active: boolean }) => {

        return <button
            onClick={() => { scrollContainer(-1) }}
            key="scroll-up"
            className={"invisible-button center-all component-scroll top " + (active ? "active" : "")}
        >
            <svg xmlns="http://www.w3.org/2000/svg" height="1.75em" viewBox="0 0 448 512" fill="white"><path d="M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z" /></svg>
        </button>

    }
    const DownArrow = ({ active }: { active: boolean }) => {

        return <button
            onClick={() => { scrollContainer(1) }}
            key="scroll-down"
            className={"invisible-button center-all component-scroll bottom " + (active ? "active" : "")}
        >
            <svg xmlns="http://www.w3.org/2000/svg" height="1.75em" viewBox="0 0 448 512" fill="white"><path d="M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z" /></svg>
        </button>

    }
    const { IsPurchasedDomain } = store.getState().Business;

    return (
        <>

            <div id="component-scroll-area" className=" left-grid-content component-container"  style={(props.manager.state.editSate == EditorState.Dragging)?{pointerEvents:"none"}:{}}  key="comp-container" ref={containerRef} onScroll={(e) => {

                checkArrows(e.target as HTMLElement)


            }}>

                <ConnectDomainClickAd DomainNotPurcheshed={IsPurchasedDomain === false}designer={props.manager}/>
                <div className="component-content" key="comp-content" ref={contentRef}>
                    {
                        allComponents.map((layout, index) => {
                            return (
                                <Accordian key={index} label={layout.label} startExpanded={true} wrapperClass="component-layout-label">



                                    {layout.components.map((compId) => {

                                        if(compId == "divider"){
                                            return <div className="divider"></div>
                                        }

                                        let component = GetWBComponentByTypename(compId);
                                        if (component == null) { return null; }


                                        return (
                                            <WBComponentSlot
                                                component={component}
                                                key={component.typename}
                                                manager={props.manager}
                                                isActive={true}
                                            />
                                        );
                                    })}
                                </Accordian>
                            );

                        })
                    }
                    <div className="w-full bottom-white-fade"></div>
                </div>
            </div>


            <h2 className="panel-heading">Design Editor</h2>

            <UpArrow active={(arrowState == 1 || arrowState == 3)} />


            <DownArrow active={(arrowState == 2 || arrowState == 3)} />
            <button type="button" className="invisible-button send-feedback-editor-btn"><a href="https://form.asana.com/?k=VTzMLzamWdeQN006ciYNYA&d=35883393372079" rel="noreferrer" target="_blank">Send Feedback</a></button>

        </>
    )




}